import { render, staticRenderFns } from "./AutomaticInvestmentButton.vue?vue&type=template&id=02fce164&scoped=true&"
import script from "./AutomaticInvestmentButton.vue?vue&type=script&lang=js&"
export * from "./AutomaticInvestmentButton.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticInvestmentButton.vue?vue&type=style&index=0&id=02fce164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fce164",
  null
  
)

export default component.exports